"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = __importDefault(require("./error"));

var request_1 = __importDefault(require("./request"));

var admin_1 = __importDefault(require("./resources/admin"));

var auth_1 = __importDefault(require("./resources/auth"));

var carts_1 = __importDefault(require("./resources/carts"));

var collections_1 = __importDefault(require("./resources/collections"));

var customers_1 = __importDefault(require("./resources/customers"));

var gift_cards_1 = __importDefault(require("./resources/gift-cards"));

var orders_1 = __importDefault(require("./resources/orders"));

var payment_methods_1 = __importDefault(require("./resources/payment-methods"));

var products_1 = __importDefault(require("./resources/products"));

var regions_1 = __importDefault(require("./resources/regions"));

var return_reasons_1 = __importDefault(require("./resources/return-reasons"));

var returns_1 = __importDefault(require("./resources/returns"));

var shipping_options_1 = __importDefault(require("./resources/shipping-options"));

var swaps_1 = __importDefault(require("./resources/swaps"));

var Medusa =
/** @class */
function () {
  function Medusa(config) {
    this.client = new request_1.default(config);
    this.admin = new admin_1.default(this.client);
    this.auth = new auth_1.default(this.client);
    this.carts = new carts_1.default(this.client);
    this.customers = new customers_1.default(this.client);
    this.errors = new error_1.default();
    this.orders = new orders_1.default(this.client);
    this.products = new products_1.default(this.client);
    this.regions = new regions_1.default(this.client);
    this.returnReasons = new return_reasons_1.default(this.client);
    this.returns = new returns_1.default(this.client);
    this.shippingOptions = new shipping_options_1.default(this.client);
    this.swaps = new swaps_1.default(this.client);
    this.collections = new collections_1.default(this.client);
    this.giftCards = new gift_cards_1.default(this.client);
    this.paymentMethods = new payment_methods_1.default(this.client);
  }

  return Medusa;
}();

exports.default = Medusa;

__exportStar(require("./typings"), exports);